import { validateUrls } from "api/types"
import { getServiceURL } from "api/utils"
import { ServicePrefix } from "utils/constants"

const getCelestialURL = getServiceURL(ServicePrefix.celestial)

export const urls = validateUrls({
  list: () => getCelestialURL("/v1/centres/courses/"),
})
